import { useContext } from "react";
import { PortalScopeContext, PortalScopeContextType } from "./context";

/**
 * The one hook every marketplace-hiding decision goes through.
 *
 * Outside the affiliate portal (brand/admin/agency shells, public pages) the
 * default context applies and nothing is hidden.
 */
export function usePortalScope(): PortalScopeContextType {
  return useContext(PortalScopeContext);
}
